import { render, staticRenderFns } from "./_datatable.vue?vue&type=template&id=1c2f3202&scoped=true"
import script from "./_datatable.vue?vue&type=script&lang=ts"
export * from "./_datatable.vue?vue&type=script&lang=ts"
import style0 from "./_datatable.vue?vue&type=style&index=0&id=1c2f3202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2f3202",
  null
  
)

export default component.exports